(function(){
    'use strict'

    angular
    .module('app.horarios')
    .controller('EditarHorario', EditarHorario);

    EditarHorario.$inject = ['$scope', '$animationsSrv', '$routeParams','HorariosService', 'logger', '$location'];

    function EditarHorario($scope, $animationsSrv, $routeParams, HorariosService, logger, $location) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.horario = {
            codigo:'',
            descripcion:'',
            horaDesde: -1,
            horaHasta: -1
        };

        vm.horas = [
            {id: 0, descripcion: 'Media Noche'},
            {id: 1, descripcion: '1 AM'},
            {id: 2, descripcion: '2 AM'},
            {id: 3, descripcion: '3 AM'},
            {id: 4, descripcion: '4 AM'},
            {id: 5, descripcion: '5 AM'},
            {id: 6, descripcion: '6 AM'},
            {id: 7, descripcion: '7 AM'},
            {id: 8, descripcion: '8 AM'},
            {id: 9, descripcion: '9 AM'},
            {id: 10, descripcion: '10 AM'},
            {id: 11, descripcion: '11 AM'},
            {id: 12, descripcion: 'Media Día'},
            {id: 13, descripcion: '1 PM'},
            {id: 14, descripcion: '2 PM'},
            {id: 15, descripcion: '3 PM'},
            {id: 16, descripcion: '4 PM'},
            {id: 17, descripcion: '5 PM'},
            {id: 18, descripcion: '6 PM'},
            {id: 19, descripcion: '7 PM'},
            {id: 20, descripcion: '8 PM'},
            {id: 21, descripcion: '9 PM'},
            {id: 22, descripcion: '10 PM'},
            {id: 23, descripcion: '11 PM'}
        ];

        vm.horarioId = $routeParams.id ? $routeParams.id : 0;

        getHorario();

        function getHorario(){

            if(vm.horarioId != 0){
                var promise = HorariosService.getById(vm.horarioId);

                promise
                .then(function(horario){
                    vm.horario = horario;
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener el horario: ' + error.data.Message);
                            break;
                    }
                });               
            }

        };

        vm.horaDesdeChange = function(){
            validateHoraDesde();
        };

        function validateHoraDesde(){
            if(vm.horario.horaDesde == -1){
                $scope.horarioForm.horaDesde.$setValidity("different", false);
            }
            else{
                $scope.horarioForm.horaDesde.$setValidity("different", true);
            }
        }

        vm.horaHastaChange = function(){
            validateHoraHasta();
        };

        function validateHoraHasta(){
            if(vm.horario.horaHasta == -1){
                $scope.horarioForm.horaHasta.$setValidity("different", false);
            }
            else{
                $scope.horarioForm.horaHasta.$setValidity("different", true);
            }
        }

        function doFormValidations(){
            validateHoraDesde();
            validateHoraHasta();
        }

        vm.save = function(){

            $scope.submitted = true;

            doFormValidations();
            
            if($scope.horarioForm.$valid){
                if(!vm.horario.id){
                    saveHorario();
                }
                else if($scope.horarioForm.$dirty){
                    updateHorario();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function saveHorario() {
            var promise = HorariosService.save(vm.horario);
            
            promise
            .then(function(response){
                logger.success('Horario creado con éxito.');
                clearHorarioData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el horario: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateHorario(){
            var promise = HorariosService.update(vm.horario);
            
            promise
            .then(function(response){
                logger.success('Horario modificado con éxito.');
                $location.path('/horarios');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el horario: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearHorarioData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.horario = {
                codigo:'',
                descripcion:'',
                horaDesde: -1,
                horaHasta: -1
            };
            // Set back to pristine.
            $scope.horarioForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.horarioForm.$setUntouched();
        };

    }
})();